import { i18n } from '../translate/i18n';

export const deleteCheckMessage = (obj) => {
  let message = i18n.t('handleDeleteEquipmentModelsFail.message');

  Object.keys(obj).map((key, index) => {
    return message += `${!!index ? ' e' : ''} ${translateLabel(key)} ${obj[key]}x`
  });

  return message
}


const translateLabel = (collection) => {
  collection = collection.toLowerCase();

  const possibleValues = [
    'companies',
    'items',
    'equipmentmodels',
    'equipments',
    'inspections',
    'itemverifications'
  ];

  const key = possibleValues.includes(collection) ? collection : 'default';
  return i18n.t(`handleDeleteEquipmentModelsFail.${key}`);
}
